module.exports = __webpack_public_path__ + "static/media/chevron-down.671f6756.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/chevron-down.svg
// module id = 1842
// module chunks = 0